<template>
    <div class="SX">
       <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoRisk">首页></span>
        <span @click="GoSiXiang">巡视巡察></span>
          <span @click="GoBJ">北京动态></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
    <div class="zhengwen">
      <h1>省委巡视高职高专第十六组巡视黄山职业技术学院动员会</h1>
      <div class="first">
        <span class="third">来源：新华社</span>
         <span class="si">|</span>
        <span>发布时间：2020-5-20 13:30</span>
      </div>
      <div class="xh"></div>
      <div class="second">
        <p>根据省委关于巡视工作的统一部署，5月13日，省委巡视高职高专第十六组巡视黄山职业技术学院党委工作动员会召开。会前，巡视组组长张力量主持召开与黄山职业技术学院党委书记王永松的见面沟通会，传达了省委书记李锦斌在省委“五人小组”会议上听取巡视有关工作汇报时的讲话精神，通报了有关工作安排。会上，张力量作了动员讲话，对做好巡视工作提出要求。王永松主持会议并作表态发言。</p>

        <strong><p> </p></strong>

        <p>巡视组副组长胡红彦及有关同志，黄山职业技术学院党委领导班子成员出席会议；黄山职业技术学院各处室、院系、中心及工会、团委负责同志，其他科级以上干部，学院在职人员中的“两代表一委员”、副教授以上职称人员及部分教职工代表列席会议。</p>

        <p>张力量强调，高校作为培养中国特色社会主义事业合格建设者和可靠接班人的重要阵地，肩负着人才培养、科学研究、社会服务等重要职责。对高校开展巡视，体现了省委对教育事业的高度重视，是推动高校党委坚持党的全面领导、做到“两个维护”的必然要求，是推动高校党委落实根本任务、践行初心使命的重要举措，是推动高校党委全面从严治党、正风肃纪反腐的有力抓手。黄山职业技术学院党委要提高政治站位，充分认识对高校开展巡视的重要意义，把接受巡视监督作为增强“四个意识”、坚定“四个自信”、做到“两个维护”的过程，强化政治担当，压实政治责任，同题共答、同向发力，积极支持配合省委巡视组工作，共同完成好省委交给的巡视任务。</p>
          <strong><p> </p></strong>

        <p>张力量指出，巡视是政治监督，是对高校党委履行政治责任和职责使命情况的全面政治体检。省委巡视组将坚持以习近平新时代中国特色社会主义思想为指导，深入贯彻党的十九大和十九届二中、三中、四中全会精神，坚守政治巡视定位，全面贯彻巡视工作方针，把“两个维护”作为根本任务，围绕中心、服务大局，强化政治监督。对照习近平总书记重要讲话和指示批示精神，对照党章党规党纪，对照立德树人根本任务，深入查找政治偏差，重点监督检查落实党的理论路线方针政策和党中央及省委重大决策部署情况，落实全面从严治党战略部署情况，落实新时代党的组织路线情况，落实巡视、审计、主题教育整改情况。</p>

        <p>王永松表示，一是提高政治站位，切实把思想和行动统一到党中央及省委关于巡视工作的决策部署上来。二是诚恳接受巡视监督，严格落实巡视工作要求，自觉对标对表，主动查找问题。三是严守政治纪律，精心组织、统筹安排，保障巡视工作有序有效开展。</p>
      </div>
    </div>
      
    
    </div>


    </div>
</template>
<script>
export default {
    methods: {
         GoRisk() {
      this.$router.push("/HOME");
    },
   GoSiXiang() {
      this.$router.push("/MakeInspectionTour");
    },
    GoBJ() {
      this.$router.push("/MakeInspectionTour/BeiJing");
    },
    },
    
}
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}
p:nth-child(1) {
  text-indent: 0;
}
h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.si{
   margin: 0 16px;
 }
</style>